<template>
  <Container>
    <div class="home_m">
      <img src="@/assets/bg1-m.png" class="bg1">
      <img src="@/assets/bg2-m.png" class="bg2">
      <div class="variable-container">
        <el-carousel :indicator-position="showIndicator" arrow="never" :autoplay="false" @change="carouselChange">
          <el-carousel-item v-for="item in videos" :key="item">
            <div class="carousel-video">
              <video
              :src="item.src"
              :poster="item.poster"
              controls
              ref="video"
              x5-video-player-type="h5-page"
              playsinline
              webkit-playsinline
              airplay="allow"
              x-webkit-airplay="allow"
              @play="videoPlayState = true"
              @pause="videoPlayState = false"
              @ended="videoPlayState = false"></video>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="story-area">
          <div class="story-info">
            <div class="cover">
              <img :src="currentStory.cover">
              <div class="total-time">{{ totalAudioDuration }}</div>
            </div>
            <div class="title" :style="{top: currentStory.audioUrl ? '-15px' : '20px'}">
              <div class="play-icon" v-if="currentStory.audioUrl" @click="audioStartPlay">
                <img src="@/assets/icon2.png" v-if="storyPlayState">
                <img src="@/assets/icon1.png" v-else>
              </div>
              <div class="play-icon" v-else></div>
              <div class="titleTex">
                <span><i>{{ currentStory.title }}</i></span>
              </div>
            </div>
          </div>
          <div class="story-desc">
            <div v-html="currentStory.desc"></div>
            <div>{{ currentStory.author }}</div>
          </div>
          <div class="share">
            <img src="@/assets/twitter.png" @click="setTwitterLink(currentStory.title)">
            <img src="@/assets/facebook.png" @click="setFacebookLink">
          </div>
        </div>
        <ul class="story-list" v-vscrollCenter="currentStoryIndex">
          <li v-for="(i, index) in audios" :class="{active: index===currentStoryIndex}" @click="currentStoryIndex = index">
            <img :src="i.cover">
            <i class="indicator" v-show="index===currentStoryIndex"></i>
            <div class="play-mask" v-show="index===currentStoryIndex">
              <img src="@/assets/icon3.png" alt="">
            </div>
          </li>
        </ul>
      </div>
      <ul class="story-controller" v-if="currentStory.audioUrl">
        <li>
          <img src="@/assets/icon10.png" @click="forwardOrback(-20)">
        </li>
        <li @click="audioStartPlay">
          <img src="@/assets/icon9.png" v-if="storyPlayState">
          <img src="@/assets/icon8.png" v-else>
        </li>
        <li>
          <img src="@/assets/icon11.png" @click="forwardOrback(20)">
        </li>
        <li class="titleTex">
          {{ currentStory.title }}
        </li>
        <li>
          <img src="@/assets/icon6.png" v-show="speed === 0.5" @click="playbackRate(1)">
          <img src="@/assets/icon7.png" v-show="speed === 1" @click="playbackRate(0.5)">
        </li>
      </ul>
    </div>
    <audio :src="currentStory.audioUrl" v-show="false" ref="audio" @ended="storyPlayState = false" @loadedmetadata="audioLoadedmetadata"></audio>
  </Container>
</template>

<script>
import Container from '@/components/container.vue';
import mixins from '@/mixins'
export default {
  name: '',
  mixins: [mixins],
  components: {
    Container
  }
}
</script>

<style lang='less' scoped>
.home_m{
  min-height: 100vh;
  background: #0156BD;
  position: relative;
  padding-top: 214px;
  .bg1{
    position: absolute;
    top: 0;
  }
  .bg2{
    position: absolute;
    bottom: 0;
  }
  .variable-container{
    width: 318px;
    margin: 0 auto;
    position: relative;
    // z-index: 1000;
    .carousel-video{
      width: 318px;
      height: 179px;
      margin: 0 auto;
      video{
        width: 100%;
        height: 179px;
      }
    }
    .story-area{
      width: 318px;
      background: #80ABDE;
      padding: 15px;
      border-radius: 10px;
      position: relative;
      .story-info{
        display: flex;
        .cover{
          width: 112px;
          height: 112px;
          border: 2px solid #fff;
          box-sizing: border-box;
          border-radius: 10px;
          overflow: hidden;
          position: relative;
          .total-time{
            position: absolute;
            bottom: 5px;
            right: 5px;
            font-size: 15px;
            color: #fff;
          }
        }
        .title {
          position: relative;
          .play-icon{
            img{
              width: 80px;
            }
          }
          .titleTex{
            width: 170px;
            padding: 0 15px;
            font-size: 19px;
            color: #fff;
          }
        }
      }
      .story-desc{
        color: #fff;
        margin-top: 10px;
      }
      .share{
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        gap: 15px;
        img{
          width: 25px;
        }
      }
    }
    .story-list{
      display: flex;
      overflow: auto;
      gap: 38px;
      padding: 15px;
      padding-top: 30px;
      li{
        flex-shrink: 0;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        border: 2px solid #fff;
        position: relative;
        box-sizing: content-box;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .play-mask{
          width: 45px;
          height: 45px;
          background: #00000070;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          left: 0;
          img{
            transform: scale(0.5);
          }
        }
      }
      .active{
        &::after{
          content: '';
          position: absolute;
          top: -40px; /* 调整三角形位置 */
          left: 50%; /* 使三角形的角尖对准li元素中心 */
          transform: translateX(-50%) rotate(180deg);
          border-width: 20px;
          border-style: solid;
          border-color: transparent transparent #80ABDE transparent;
        }
      }
    }
  }
  .story-controller{
    width: 100vw;
    height: 66px;
    background: #23293c9f;
    position: relative;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 14px;
    li{
      width: 28px;
      height: 28px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .titleTex{
      flex: 1;
      color: #fff;
      font-size: 11px;
      display: flex;
      align-items: center;
    }
  }
}
::v-deep .main-footer{
  margin-top: 0 !important;
}
</style>